module.exports = __webpack_public_path__ + "img/sale-ruokailuryhmat.a9c74409.jpeg";